<template>
  <div
    v-if="!!savedAudioRecordLength"
    :class="`position-fixed ${
      checkScreenDevice(['tablet', 'mobile']) ? 'bottom-70' : 'bottom-100'
    }  ${
      checkScreenDevice(['tablet', 'mobile']) ? 'right-20' : 'right-272'
    }  height-48 border-radius-200 background-surface color-complementary-200 box-shadow--widget flex-start position-absolute bottom-24 z-index-99 cursor--pointer padding-12`"
    @click.stop="goTo"
  >
    <zoom-center-transition>
      <span
        class="chips chips--error chips--pill pb-0 position-absolute top--10 right--10"
      >
        {{ savedAudioRecordLength }}
      </span>
    </zoom-center-transition>
    <span>
      <mdicon name="volume-high" size="24" />
    </span>
  </div>
</template>

<script>
import {
  generateStoreGetters,
  goToRoute,
  checkScreenDevice,
} from "@/shared/utils";
import { computed } from "vue";

export default {
  props: {
    rowClass: {
      type: String,
      default: "",
    },
  },
  setup() {
    const savedAudioRecordLength = computed(() =>
      generateStoreGetters(["savedAudioRecordLength"])
    );
    const goTo = () => goToRoute("recorded-voice", {}, {}, false);

    return {
      savedAudioRecordLength,
      checkScreenDevice,
      goTo,
    };
  },
};
</script>
